import { useEffect } from "react";
import { useRouter } from "next/router";
import { ProductByHandleQuery } from "../../../../lib/shopify/sdk";
import { NestedOptions } from "./NestedOptions";
import { RegularOptions } from "./RegularOptions";
import { SingleOption } from "./SingleOption";

interface Props {
  product: ProductByHandleQuery["productByHandle"];
  setPickedOption: (value: string) => void;
  isProductCard?: boolean;
}

export const OptionSelector = ({
  product,
  setPickedOption,
  isProductCard = false,
}: Props) => {
  const { query, replace } = useRouter();
  const autoDiscount =
    product?.autoDiscount?.value && product?.autoDiscount?.value !== "0"
      ? String(product?.autoDiscount?.value)
      : null;
  const mostPopularVariant = product?.mostPopularVariant?.value;
  const isNested = product?.isNested?.value;
  const convertVariants = () => {
    const variants = {};
    const refillVariants = {};
    product.variants.edges.forEach(({ node }) => {
      const isRefill = node?.refill?.value;
      if (isRefill) {
        const value = refillVariants[node.selectedOptions[0].value];
        if (!value) refillVariants[node.selectedOptions[0].value] = [node];
        else
          refillVariants[node.selectedOptions[0].value] = [
            ...refillVariants[node.selectedOptions[0].value],
            node,
          ];
      } else {
        const value = variants[node.selectedOptions[0].value];
        if (!value) variants[node.selectedOptions[0].value] = [node];
        else
          variants[node.selectedOptions[0].value] = [
            ...variants[node.selectedOptions[0].value],
            node,
          ];
      }
    });
    return [Object.entries(variants), Object.entries(refillVariants)];
  };
  useEffect(() => {
    if (product.variants.edges.length === 1) {
      const route = {
        query: {
          ...query,
          variantId: product.variants.edges[0].node.id.replace(
            /gid:\/\/shopify\/.*\//i,
            ""
          ),
        },
      };
      replace(route, undefined, { shallow: true });
    }
  }, [product]);
  const [regularVariants, refillVariants] = convertVariants();
  if (product.options.length === 1 && product.variants.edges.length > 1)
    return (
      <SingleOption
        options={product.options}
        refillVariants={refillVariants as any}
        regularVariants={regularVariants as any}
        autoDiscount={autoDiscount}
        mostPopularVariant={mostPopularVariant}
        maxHeight={isProductCard ? "300px" : "max-content"}
        overflow={"auto"}
      />
    );
  if (isNested)
    return (
      <NestedOptions
        refillVariants={refillVariants as any}
        regularVariants={regularVariants as any}
        autoDiscount={autoDiscount}
        mostPopularVariant={mostPopularVariant}
        options={product.options}
        setPickedOption={setPickedOption}
        maxHeight={isProductCard ? "300px" : "max-content"}
        overflow={"auto"}
      />
    );
  if (product.variants.edges.length > 1)
    return (
      <RegularOptions
        options={product.options}
        regularVariants={regularVariants}
        refillVariants={refillVariants}
        autoDiscount={autoDiscount}
        mostPopularVariant={mostPopularVariant}
        setPickedOption={setPickedOption}
        maxHeight={isProductCard ? "300px" : "max-content"}
        overflow={"auto"}
      />
    );
  return null;
};
